<template>
  <div class="container" ref="wrapper">
    <van-nav-bar title="客户定制" left-arrow @click-left="$router.replace({ path: '/' })">
    </van-nav-bar>
    <van-sticky>
      <van-dropdown-menu>
        <van-dropdown-item v-model="page.filterData.flowStatus" :options="flowStatusOptions" @change="onSearch" />
        <van-dropdown-item title="更多筛选" ref="filter">
          <van-field readonly clickable name="calendar" :value="page.filterData.timeRange" label="选择日期范围"
            placeholder="点击选择" @click="showCalendar = true" />
          <van-calendar v-model="showCalendar" type="range" @confirm="onSelectedTimeRange" :min-date="minDate" />
          <van-field v-model="page.filterData.code" type="digit" label="定制编号" placeholder="请输入定制编号" />
          <van-field v-model="page.filterData.saleID" label="A3订单编号" placeholder="请输入A3订单编号" />
          <van-field v-model="page.filterData.memberId" label="A3客户编号" placeholder="请输入A3客户编号" />
          <div style="padding: 5px 16px">
            <van-button round style="width: 45%" @click="onReset">
              重置
            </van-button>
            <van-button type="danger" round :loading="loading" style="width: 45%; margin-left: 9%" @click="
              () => {
                this.$refs.filter.toggle(false);
                onSearch();
              }
            ">
              确定
            </van-button>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-cell-group v-for="item in list" :key="item.id">
          <van-cell title-class="van-cell-title4" center>
            <template #title>
              <div style="float: right; margin-left: 5px; cursor: pointer">
                <van-tag type="success" round plain v-if="item.flowStatus == 0">待审核</van-tag>
                <van-tag type="success" round plain v-else-if="item.flowStatus == 10">已审核</van-tag>
                <van-tag type="success" round plain v-else-if="item.flowStatus == 20">设计已审核</van-tag>
                <van-tag type="success" round plain v-else-if="item.flowStatus == 100">已完成</van-tag>
              </div>
              <div style="float: right; cursor: pointer">
                <van-tag type="danger" v-if="item.flowStatus == 0" @click="showAudit(item)">点我审核</van-tag>
              </div>
            </template>
            <template #label>
              <van-row>
                <van-col span="7"><strong>定制编号：</strong></van-col>
                <van-col span="17">{{ item.code }}</van-col>
              </van-row>
              <van-row>
                <van-col span="7"><strong>订单编号：</strong></van-col>
                <van-col span="17">{{ item.saleID }}</van-col>
              </van-row>
              <van-row>
                <van-col span="7"><strong>定制产品：</strong></van-col>
                <van-col span="17">{{ item.productName }}</van-col>
              </van-row>
              <van-row>
                <van-col span="7"><strong>创建时间：</strong></van-col>
                <van-col span="17">{{ item.creationTime | dateFormat("YYYY/MM/DD HH:mm") }}</van-col>
              </van-row>
              <van-row>
                <van-col span="7"><strong>定制原因：</strong></van-col>
                <van-col span="17">{{ item.remark }}</van-col>
              </van-row>
              <van-row>
                <van-col span="7"><strong>A3客户编号：</strong></van-col>
                <van-col span="17">{{ item.memberId }}</van-col>
              </van-row>
              <van-row>
                <van-col span="7"><strong>A3客户姓名：</strong></van-col>
                <van-col span="17">{{ item.memberName }}</van-col>
              </van-row>
              <van-row>
                <van-col span="7"><strong>我的备注：</strong></van-col>
                <van-col span="17">{{ item.employeeRemark }}</van-col>
              </van-row>
              <van-row>
                <van-col span="7"><strong>客户设计图：</strong></van-col>
                <van-col span="17">
                  <van-tag style="cursor: pointer" type="primary" @click="showDesignImg(item)">点我查看</van-tag>
                </van-col>
              </van-row>
              <van-row v-if="item.flowStatus>=20">
                <van-col span="7"><strong>预计完成时间：</strong></van-col>
                <van-col span="17">{{ item.estimatedTime | dateFormat("YYYY/MM/DD") }}</van-col>
              </van-row>
            </template>
            <!-- <template #extra>
              <span style="cursor: pointer" @click="toedit(item)"><van-icon name="arrow" /></span>
            </template> -->
          </van-cell>
        </van-cell-group>
      </van-list>
    </van-pull-refresh>
    <van-action-sheet v-model="showPreviewImageDialog" title="设计图" style="text-align: center;">
      <img :src="currentItem.previewImage" alt="设计图" style="max-width: 100%; max-height: 80vh;">
    </van-action-sheet>
    <van-popup v-model="showAuditDialog" :style="{ width: '90%',maxWidth: '574px' }" closeable>
      <p style="margin: 15px;text-align: center;font-weight: bold;">审核</p>
      <van-form @submit="submitAudit()">
        <van-field readonly clickable name="picker" :value="currentItem.saleID" label="关联A3订单" placeholder="点击选择A3订单"
          @click="showOrderPicker = true" required :rules="[{ required: true, message: '请关联A3订单' }]" />
        <van-field v-model="currentItem.employeeRemark" autosize label="备注" type="textarea" maxlength="100"
          placeholder="请输入备注" show-word-limit />
        <div style="padding: 10px;"><van-button type="info" round block native-type="submit">确定</van-button></div>
      </van-form>
    </van-popup>
    <van-popup v-model="showOrderPicker" position="bottom">
      <van-picker show-toolbar :columns="saleIDs" @confirm="currentItem.saleID = $event, showOrderPicker = false"
        @cancel="showOrderPicker = false" />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getCustomizedList, addOrEditCustomized, getA3OrderListByA3UserId } from "@/api/a3user";
export default {
  data() {
    return {
      scroll: 0,
      loading: false,
      refreshing: false,
      finished: false,
      list: [],
      page: {
        current: 1,
        pageSize: 10,
        sorterType: 0,
        fromType: 1,
        filterData: {
          timeRange: "",
          code: null,
          saleID: '',
          memberId: '',
          flowStatus: null,
        },
      },

      flowStatusOptions: [
        { text: "全部状态", value: null },
        { text: "待审核", value: 0 },
        { text: "已审核", value: 10 },
        { text: "设计已审核", value: 20 },
        { text: "已完成", value: 100 },
      ],
      showCalendar: false,
      minDate: new Date(2025, 1, 1),

      currentItem: {},
      showPreviewImageDialog: false,

      showAuditDialog: false,
      showOrderPicker: false,
      saleIDs: [],
    };
  },
  components: {},
  computed: {
  },
  created() {
  },
  //此钩子函数会反复触发,是keep-alive特有的钩子函数，取滚动高度
  activated() {
    this.$refs.wrapper.scrollTop = this.scroll || 0;
  },
  //路由离开时的钩子函数,存储滚动高度
  beforeRouteLeave(to, from, next) {
    this.scroll = this.$refs.wrapper.scrollTop || 0;
    next();
  },

  updated() { },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (from.path == "/customized/add") {
        this.onRefresh();
      }
    },
  },
  mounted() { },
  methods: {
    async onLoad() {
      let d = await getCustomizedList({
        ...this.page,
        filterData: {
          ...this.page.filterData,
          code: parseInt(this.page.filterData.code),
        }
      });
      if (!d.data.success && d.data.errorMessage) {
        Toast(d.data.errorMessage);
        return;
      }

      this.list.push(...d.data.data);
      this.loading = false;
      this.refreshing = false;
      if (this.page.current * this.page.pageSize < d.data.total) {
        this.page.current++;
      } else {
        this.finished = true;
      }
    },
    onRefresh() {
      this.list = [];
      this.page.current = 1;
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    onSearch() {
      this.list = [];
      this.page.current = 1;
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    async onSelectedTimeRange(date) {
      const [start, end] = date;
      this.showCalendar = false;
      this.page.filterData.timeRange = `${this.dayjs(start).format(
        "YYYY/MM/DD"
      )} - ${this.dayjs(end).format("YYYY/MM/DD")}`;
      this.$refs.filter.toggle(true);
      await this.onSearch();
    },

    async onReset() {
      this.page.filterData.timeRange = '';
      this.page.filterData.code = null;
      this.page.filterData.saleID = '';
      this.page.filterData.memberId = '';
      this.page.filterData.flowStatus = null;
    },

    async showDesignImg(item) {
      this.currentItem = item;
      this.showPreviewImageDialog = true;
    },
    async showAudit(item) {
      this.currentItem = item;
      const res = await getA3OrderListByA3UserId({ a3userId: this.currentItem.creatorId });
      this.saleIDs = res.data.data.map(x => x.saleID + "");
      this.showAuditDialog = true
    },
    async submitAudit() {
      this.currentItem.flowStatus = 10;
      const res = await addOrEditCustomized(this.currentItem);
      if (!res.data.success) {
        this.currentItem.flowStatus = 0;
        Toast(res.data.errorMessage);
        return;
      }
      Toast("审核成功");
      this.showAuditDialog = false;
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
}

.van-cell-title4 {
  -webkit-box-flex: 4;
  flex: 4;
}

.van-col--17,
.van-col--7 {
  width: auto;
}
</style>